import { Box, Group } from "@mantine/core";
import type { ReactNode } from "react";

export default function ModalFooter({ children }: { children: ReactNode }) {
  return (
    <Box style={{ zIndex: 1000 }} pos="sticky" bottom={0} bg={"var(--mantine-color-default)"}>
      <Group align="center" justify="flex-end" gap="xs" p="sm">
        {children}
      </Group>
    </Box>
  );
}
